/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../application";
import { OWNED_ASSETS } from "../pages/OwnedAssets/graphql/owned-assets.query"
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {TEST_DATA } from "./config/assets-test-data"
import {useAsset} from "../pages/ClaimAssets/provider"
import {SOUND,VIDEO } from "../assets"

const MODULE_NAME = "OwnedAssetsService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

interface IProps{
    imageServer:any
}

export class OwnedAssetsService {
    private static instance: OwnedAssetsService;
    private vapp: VApplication;
    private imageServer;
    private constructor(props:IProps | any = {}) {
        this.vapp = VApplication.getInstance();
        this.imageServer = props?.imageServer
      
    }

    
    public static getInstance(props:IProps |  any = {}): OwnedAssetsService {
        if (!OwnedAssetsService.instance) {
            OwnedAssetsService.instance = new OwnedAssetsService(props);
        }
        return OwnedAssetsService.instance;
    }

  
    async getAssets(size: number, offset: number) {
        const getassetsService = OwnedAssetsService.getInstance();
        const{ id}= useAsset();
        console.log("storeid-owned",id)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: OWNED_ASSETS,
                    variables: {
                        size: size,
                        offset: offset,
                        filter: {
                            state: ["minted","mint_pending"],
                            // store:id
                          }
                    },
                    fetchPolicy:'network-only'
                });
                log.success(MODULE_NAME, "get owned assets result: ", res);
                // return res?.data?.getAssets;
                if(res){
                    let _data= res?.data?.getAssets?.data;
                                      
                    let results = _data?.map((item:any)=>{
                        console.log("asset state",item?.state)
                        
                        const imgUrl = item?.img;
                        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
                        const imgBBformat = imgUrl?.split('/');
                        const ibbFormat = imgBBformat[imgBBformat.length-3]
                     
                        let _img;
                         if(ibbFormat === "i.ibb.co"){
                            // _img =`${getassetsService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                            _img = item?.img
                         
                         } 
                         else {
                            //  _img = `${getassetsService.imageServer}${urlFormat}/:/rs=h:500`
                            _img = item?.img
                         }
                          console.log("mui",_img)
                          
                          if(item?.type === "audio"){
                            _img = item?.thumbnail ?? SOUND
                        }
                        if(item?.type === "video"){
                            _img = item?.thumbnail ?? VIDEO
                        }
                    
                    

                        return({
                            ...item,
                            img:_img,
                            storeId:id,
                            tag: null,
                            networkType:null,
                            // category: item?.tag?.toLowerCase(),
                            tokenId:item?.serialNo,
                            serialNo:`Rare #/${item?.serialNo}`,
                            subtitle:item?.subtitle.replace(/<[^>]*>?/gm, ''),
                            audioDetail: item?.type === "audio" ? true : false,
                            videoDetail: item?.type === "video" ? true : false,
                            ribbon :item?.state ==="mint_pending" ? {backgroundColor:"red",value:"Mint pending"} : null
                                
                            
                        })
                    })
                    return{
                        pagination: {
                            nextOffset: offset + res?.data?.getAssets?.pageSize,
                            totalItems: res?.data?.getAssets?.totalCount
                        },  
                        results
                    }
                }
            }
        } catch (err) {
            log.error(MODULE_NAME, "error in get assets", err);
            // throw Error(`${err?.message}`)
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }
}
